
import {
    onMounted,
    ref,
    defineAsyncComponent,
 } from 'vue'; 

import useMarcas from '@/modules/ventas/composables/useMarcas';

export default {
    components: {
        MarcaEditarComponent: defineAsyncComponent(
            () => import('@/modules/ventas/components/MarcaEditarComponent.vue')
        ),
    },
    setup() {
        const {
            obtenerMarcas,
        } = useMarcas();

        const fitroBusqueda = ref<any>({
            textoBuscar: ''
        });

        const headers = [
            { text: 'Nombre', value: 'nombre', sortable: true },
            { text: 'Estado', value: 'estado', sortable: true },
            { text: '', value: 'acciones', width: 15 },
        ];

        let marcas: any = [];
        const marcasFiltrados = ref<any[]>([]);

        const textoFiltro = ref<string>('');

        const marcaEditarComponentRef = ref();

        onMounted(async() => {
            await buscarMarcas();
        });

        const buscarMarcas = async () => {
            const resp = await obtenerMarcas(fitroBusqueda.value.textoBuscar);
            if (resp.ok) {
                marcas = resp.data;
                marcasFiltrados.value = JSON.parse(JSON.stringify(marcas));
            }
        }

        const nuevaMarca = async () => {
            marcaEditarComponentRef.value.abrirComponent();
        }

        const editarMarca = async (marca: any) => {
            marcaEditarComponentRef.value.abrirComponent(JSON.parse(JSON.stringify(marca)));
        }

        const filtrarInformacion = async () => {
            marcasFiltrados.value = JSON.parse(JSON.stringify(
                marcas.filter(
                    (u: any) => u.nombre.toLowerCase().includes(textoFiltro.value.toLowerCase())
                )
            ));
        }

        const cerrarEditarMarcaComponentEmit = async(seGrabo: boolean) => {
            if (seGrabo) {
                await buscarMarcas();
            }
        }

        return {
            fitroBusqueda,
            headers,
            textoFiltro,
            marcasFiltrados,

            buscarMarcas,
            editarMarca,
            filtrarInformacion,
            nuevaMarca,

            marcaEditarComponentRef,
            cerrarEditarMarcaComponentEmit,
        };
    }
}
